
import Vue,{Events} from "vue"
import {EDirection, ETrigger, props} from './prop'
export default Vue.extend({
	data(){
		return {
			triggerElm:null as HTMLElement|null,
			showTooltip: false,
			vshowControl: false,
			clickOutArea(){
               if(this.showTooltip){
				  this.showTooltip = false
			   }
			   
			}
		
		}
	},
   props,
   mounted(){
	 this.$nextTick(()=>{
		  this.triggerElm = this.$refs['triggerElm'] as any		  
	 })
	 window.addEventListener('click',this.clickOutArea.bind(this))
	
   },
   beforeDestroy(){
     window.removeEventListener('click',this.clickOutArea)
   },
   computed:{
	  popPostion(){
		 if(!this.triggerElm){
			return ''
		 }
		 const height = this.triggerElm.clientHeight
		 const width = this.triggerElm.clientWidth
		 let res: Partial<CSSStyleDeclaration> = {
			
		  }
		 switch(this.direction){
			case EDirection.left:
              res = {
                 right:-width + 'px',
			  }
			  break
			case EDirection.right:
				res = {
                   left: width + 'px'
				}
				break
			case EDirection.top:
				res = {
					top:-height+'px'
				}
				break
			case EDirection.bottom:
				res = {
					top:height+'px'
				}
		 }
		 res.opacity = this.showTooltip?'1':'0'
		 res.visibility = this.showTooltip?"visible":'hidden'
		 return res
	  },
	  events(){
		 const res: Record<string,(...arg: any)=>any> = {}
		 if(this.trigger === ETrigger.hover){
			 res.mouseenter = ()=>this.showTooltip=true
		 }else if(this.trigger===ETrigger.click){
             res.click = (e:any)=>{
			    e.stopPropagation()
				this.showTooltip = !this.showTooltip
			 }
		 }
		 return res
	  },
	  outEvent(){
		 const res:Record<string,(...arg: any)=>any> = {}
		 if(this.trigger === ETrigger.hover){
			res.mouseleave = ()=>this.showTooltip = false
		 }
		 return res
	  }
   },
   watch:{
	  showTooltip(){
		if(this.showTooltip){
			this.vshowControl = this.showTooltip
		}else{
			setTimeout(() => {
				this.vshowControl = this.showTooltip
			}, 1000);
		}
	  }
   }

})
